function checkSupportWebp() {
  const elem = document.createElement('canvas')
  if (elem.getContext && elem.getContext('2d')) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0
  }
  return false
}

const isServer = typeof window === 'undefined'
const ratio = (function() {
  if (isServer) {
    return 1
  }
  return window.devicePixelRatio / 2
})()
const supportWebp = checkSupportWebp()
const isZLJCDN = /(cdn.huodao)|(huodaoimg)/
const isZZCDN = /zhuanstatic.com/

function doChange(url, width, height) {
  if (!isZLJCDN.test(url) && !isZZCDN.test(url)) {
    return url
  }
  let dot = url.indexOf('?') === -1 ? '?' : '&'
  let w = ''
  let h = ''
  if (isZZCDN.test(url)) {
    w = width && !/[&?]w=/i.test(url) ? dot + 'w=' + width : ''
    dot = w ? '&' : dot
    h = height && !/[&?]h=/i.test(url) ? dot + 'h=' + height : ''
    url += w + h
    if (supportWebp) {
      url += dot + 't=5&qa=90'
    }
  } else if (isZLJCDN.test(url)) {
    w = width && !/(\/resize,)w_/i.test(url) ? dot + 'x-oss-process=image/resize,w_' + width : ''
    dot = w ? '' : dot
    h =
      height && !/(\/resize,h_)|(\/resize,w_\S*,h_)/i.test(url)
        ? dot + (w ? ',h_' : 'x-oss-process=image/resize,h_') + height
        : ''
    url += w + h
    if (supportWebp) {
      if (w || h || /x-oss-process=image/i.test(url)) {
        url += '/format,webp'
      } else {
        url += dot + 'x-oss-process=image/format,webp'
      }
    }
  }
  return url
}
export default function setPicSize(imgs, w?, h?) {
  if (!imgs) {
    return imgs
  }
  w = Math.floor((w || 0) * ratio)
  h = Math.floor((h || 0) * ratio)
  if (imgs instanceof Array) {
    imgs = imgs.map((item) => {
      return doChange(item, w, h)
    })
  } else {
    return doChange(imgs, w, h)
  }
  return imgs
}
